export const HOUR_MINUTE = "hourMinute";
export const MONTH_YEAR = "monthYear";

export const NOW = -1;
